/* eslint-disable no-debugger */
import * as Yup from 'yup';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack5';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton } from '@material-ui/lab';
import { Box, Card, Grid, Stack, TextField } from '@material-ui/core';
import CaseConvertor from '../../common-components/CaseConvertor';
// redux
import { useDispatch, useSelector } from '../../../redux/store';
import { createClient, updateClient, resetCreateClientStatus, resetClientError } from '../../../redux/slices/client';
// routes

CreateClientForm.propTypes = {
  editId: PropTypes.number,
  setVisibleComponent: PropTypes.func,
  currentClient: PropTypes.object
};

export default function CreateClientForm({ editId, setVisibleComponent, currentClient = {} }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { error, createClientStatus, isLoading } = useSelector((state) => state.client);

  useEffect(() => {
    if (error || createClientStatus) {
      enqueueSnackbar(
        (createClientStatus && (!editId ? 'New Client Created Successfully' : 'Client Updated Successfully')) ||
          (error && error),
        { variant: error ? 'error' : 'success' }
      );
      dispatch(resetClientError());
    }
    if (createClientStatus) {
      setVisibleComponent('List');
      formik.resetForm();
      dispatch(resetCreateClientStatus());
    }
  }, [error, createClientStatus]);

  const NewClientSchema = Yup.object().shape({
    clientName: Yup.string().required('Client Name is required'),
    email: Yup.string().required('Email is required').email()
  });

  const editTempData = {
    editClientName: currentClient.client_name ? currentClient.client_name : '',
    editEmail: currentClient.email ? currentClient.email : ''
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      clientName: editId ? editTempData.editClientName : '',
      email: editId ? editTempData.editEmail : ''
    },
    validationSchema: NewClientSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        const clientData = {
          client_name: CaseConvertor(values.clientName),
          email: values.email
        };
        dispatch(!editId ? createClient(clientData) : updateClient(clientData, editId));
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              <Stack spacing={3}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                  <TextField
                    fullWidth
                    label="Client Name"
                    {...getFieldProps('clientName')}
                    required
                    value={values.clientName}
                    error={Boolean(touched.clientName && errors.clientName)}
                    helperText={touched.clientName && errors.clientName}
                  />
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                  <TextField
                    fullWidth
                    label="Email"
                    {...getFieldProps('email')}
                    value={values.email}
                    required
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Stack>

                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <LoadingButton type="submit" variant="contained" loading={isLoading}>
                    {!editId ? 'Save' : 'Save Changes'}
                  </LoadingButton>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}
